import React from "react";
import AppLayout from "../../Layout/AppLayout";
import HeroSection from "../LogIn/HeroSection";
import LoginPanel from "../LogIn/LoginPanel";

const SecureAccessPage = () => {
  return (
    <AppLayout>
      <div className="flex flex-col md:flex-row h-screen overflow-hidden">
        <HeroSection />
        <LoginPanel />
      </div>
    </AppLayout>
  );
};

export default SecureAccessPage;